var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShortTermPredictionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 231.6 231.6",
    style: {
      enableBackground: "new 0 0 231.6 231.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M115.8,231.6c63.8,0,115.8-51.9,115.8-115.8C231.6,51.9,179.6,0,115.8,0C51.9,0,0,51.9,0,115.8 C0,179.6,51.9,231.6,115.8,231.6z M115.8,31.6c46.4,0,84.2,37.8,84.2,84.2S162.2,200,115.8,200s-84.2-37.8-84.2-84.2 S69.4,31.6,115.8,31.6z M76.2,160.3l-7.2-7.7l34.1-32.2V56.8h25.3v46.3H169v25.3h-58.9L76.2,160.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortTermPredictionIcon);
export default __webpack_public_path__ + "static/media/short_term_prediction_icon.ea8a52ed1d15f8f093d2b5c8eaf5e333.svg";
export { ForwardRef as ReactComponent };